import { DoctorPicker } from 'views/pickers';
import { ErrorMessage } from 'views/components';
import PropTypes from 'prop-types';
import { patientActions } from 'core/Patient';
import { useTranslation } from 'react-i18next';
import {
    ButtonFooter,
    ExpandButton,
    FormGroup,
    Modal
} from 'mol-ui';
import {
    Container,
    Text
} from './styled';
import React, { useEffect } from 'react';
import {
    useDispatch,
    useInput,
    useSelector
} from 'hooks';

const AttachModal = ({
    active,
    onToggle,
    patientId
}) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const {
        attachStatus: {
            error,
            loading,
            success
        }
    } = useSelector('patient');
    const [doctorInput, doctorId] = useInput(null);
    
    const modalProps = {
        active,
        onToggle,
        width: '320px'
    };
    
    useEffect(() => {
        if (active || doctorId) {
            dispatch(patientActions.setPatientAttachStatus({}));
        }
    }, [active, doctorId]);

    const handleAttach = () => {
        const data = {
            doctor_id: doctorId,
            patient_id: patientId
        };
        dispatch(patientActions.attachPatient(data));
    };

    return (
        <Modal { ...modalProps }>
            <Container success={ success }>
                <FormGroup label={ t('Profesional') } width="100%">
                    <DoctorPicker
                        { ...doctorInput }
                        allowNone={ false }
                        disabled={ loading || success }
                    />
                </FormGroup>
                <ErrorMessage relative error={ error } />
                {
                    success &&
                    <Text>
                        { t('El paciente ha sido asociado con éxito') }
                    </Text>
                }
                <ButtonFooter margin="20px 0px 0px 0px">
                    <ExpandButton
                        danger
                        caption={ t('Volver') }
                        size={ 100 }
                        onClick={ onToggle }
                    />
                    {
                        doctorId && !success &&
                        <ExpandButton
                            caption={ t('Asociar') }
                            loading={ loading }
                            size={ 100 }
                            onClick={ handleAttach }
                        />
                    }
                </ButtonFooter>
            </Container>
        </Modal>
    );

};

AttachModal.propTypes = {
    active: PropTypes.bool,
    onToggle: PropTypes.func,
    patientId: PropTypes.number
};

export default AttachModal;
